import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-question-category',
  templateUrl: './question-category.component.html',
  styleUrls: ['./question-category.component.css'],
})
export class QuestionCategoryComponent implements OnInit {
  @Input() categorieObject: any = {};
  @Input() id: number;
  @Input() parentObject: string;
  @Input() customFormId: number;
  @Input() routerState: any;
  @Input() editable = true;
  public questions = [];
  public mainQuestions = [];
  public beforeList = [];
  public afterList = [];
  public signatureList = [];

  constructor() {}

  ngOnInit(): void {
    this.questions = this.categorieObject.questions;

    this.mainQuestions = this.questions.filter(
      (question) =>
        question.questionAnswers !== 'full_width_before' &&
        question.questionAnswers !== 'full_width_after' &&
        question.questionAnswers !== 'signature' &&
        question.questionAnswers !== 'question_full_width_before' &&
        question.questionAnswers !== 'question_full_width_after'
    );
    this.beforeList = this.questions.filter(
      (question) =>
        question.questionAnswers === 'full_width_before' ||
        question.questionAnswers === 'question_full_width_before'
    );
    this.afterList = this.questions.filter(
      (question) =>
        question.questionAnswers === 'full_width_after' ||
        question.questionAnswers === 'question_full_width_after'
    );
    this.signatureList = this.questions.filter(
      (question) => question.questionAnswers === 'signature'
    );
  }

  trackQuestion(index, question) {
    return question ? question.questionId : undefined;
  }
}
